import { render, staticRenderFns } from "./KinerjaPo.vue?vue&type=template&id=24aa521d&"
import script from "./KinerjaPo.vue?vue&type=script&lang=js&"
export * from "./KinerjaPo.vue?vue&type=script&lang=js&"
import style0 from "./KinerjaPo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports